import { useSelector } from "react-redux";
import useSubscribe from "../../../../../../custom-hooks/useSubscribe";
import { getProjectsObject } from "../../../../../../selectors/projects";
import { getCurrentProjectID } from "../../../../../../app_shared_functions";
import { getNetworksFromRedux } from "../../../../../../selectors/resources";
import { valuesOf } from "../../../../../../shared-functions/objects";
import {
  getSelectItemClassName,
  safeToLowerCase,
} from "../../../../../../shared-functions/string";

const useNetwork = (region: string) => {
  useSubscribe("NETWORKS_LIST");

  const projects = useSelector(getProjectsObject);
  const projectId = getCurrentProjectID(projects, region);

  const { resourcesList: networksObject, zonesLeft } =
    useSelector(getNetworksFromRedux);

  const networks = valuesOf(networksObject).filter(
    (network) =>
      safeToLowerCase(network.region) === safeToLowerCase(region) &&
      network.project_id === projectId,
  );

  const options = networks.map((network) => ({
    key: String(network.id),
    value: String(network.id),
    text: String(network.name),
    className: getSelectItemClassName(String(network.name)),
  }));

  return { options, loading: zonesLeft > 0 };
};

export default useNetwork;
